<template>
    <v-app>
        <v-container class="not-found" fluid>
            <v-row align="center" justify="center">
                <v-col cols="10" sm="8" md="4">
                    <v-card class="text-center pa-4 card-404" elevation="10">
                        <h1 class="text-h1">404</h1>
                        <p class="text-h5">Stranica ne postoji.</p>
                        <p class="mb-0">Vratite se nazad na <OtisakLink to="/">početnu</OtisakLink>.</p>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import OtisakLink from "@/components/OtisakLink";

export default {
    name: 'NotFound',

    components: {
        OtisakLink
    }
}
</script>

<style lang="scss" scoped>
.not-found {
    background-image: url('../../public/images/backgounds/404.jpg');
    background-size: cover;
    object-fit: cover;
    background-repeat: no-repeat;
    background-position: 72% 50%;
    height: 100vh;
    display: flex;
    align-items: center;

    .card-404 {
        background-color: rgba(255, 255, 255, 0.52) !important;
        backdrop-filter: blur(4px);
    }
}
</style>
